import React, { Component } from 'react';
class getUltimosPedidos extends Component {
  render() {
    return (
      <div>Ultimos Pedidos</div>
    );
  }
}
export default getUltimosPedidos;
